import React, { useRef, useEffect, useState } from 'react'
import jsonpath from 'jsonpath'
import moment from 'moment';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
const ShowPdfData = ({ company = {}, data = {}, pdfData, item = {}, test = [] }) => {
    const customerRef = useRef([])
    // const checksheetdata = test.filter(one => one.InspectionType == 'Retrospective Inspection' && (one.DateTime).split('T')[0] == (data.DateTime.split('T')[0]) && one.Item === data.Item
    // )
    pdfData && pdfData['Last Part Inspection'] && pdfData['Last Part Inspection'].length > 0 && pdfData['Last Part Inspection'].forEach(x => pdfData['Process/Product Patrol Inspection'].push(x))

    const [pdfdata, setpdfdata] = useState([])
    useEffect(() => {
        if (pdfData && pdfData['Setup Approval Inspection'] && pdfData['Setup Approval Inspection'].length > 0) {
            pdfData['Setup Approval Inspection'].sort((a, b) => new Date(a.DateTime) - new Date(b.DateTime))
            const pdfformater = pdfData && pdfData['Setup Approval Inspection'] && pdfData['Process/Product Patrol Inspection']
                ? pdfData['Setup Approval Inspection'].reduce((acc, item, idx) => {
                    const nextSetup = pdfData['Setup Approval Inspection'][idx + 1];

                    // Find all patrol inspections between the current and the next setup inspection
                    const productPatrolInspections = pdfData['Process/Product Patrol Inspection'].filter(item1 => {
                        if (nextSetup) {
                            return new Date(item.DateTime) <= new Date(item1.DateTime) && new Date(item1.DateTime) <= new Date(nextSetup.DateTime);
                        } else {
                            return new Date(item.DateTime) <= new Date(item1.DateTime);
                        }
                    });

                    // If there are no patrol inspections for this setup, add the setup to the previous group
                    if (productPatrolInspections.length === 0 && acc.length > 0) {
                        acc[acc.length - 1]['Setup Approval Inspection'].push(item);
                    } else {
                        // Otherwise, create a new group with the setup and its patrol inspections
                        acc.push({
                            'Setup Approval Inspection': [item],
                            'Process/Product Patrol Inspection': productPatrolInspections
                        });
                    }

                    return acc;
                }, [])
                : [{
                    'Setup Approval Inspection': pdfData['Setup Approval Inspection'] || [],
                    'Process/Product Patrol Inspection': pdfData['Process/Product Patrol Inspection'] || []
                }];;


            // Correct sorting by accessing the DateTime property correctly
            pdfformater.sort((a, b) => {
                return new Date(a['Setup Approval Inspection'][0].DateTime).getTime() - new Date(b['Setup Approval Inspection'][0].DateTime).getTime();
            });

            // Set the sorted data
            setpdfdata(pdfformater);
        } else {



            setpdfdata([{
                'Setup Approval Inspection': [],
                'Process/Product Patrol Inspection': pdfData['Process/Product Patrol Inspection'] || []
            }]);

        }

    }, [pdfData])

    console.log(pdfdata, "current pdf data")


    console.log(data, "sdcssdkc", pdfData, pdfdata)
    function extractData(json, path) {
        if (json) {
            const result = jsonpath.query(json, path);
            return result;
        }
        return '-'

    }
    function calculateTotalDefectQty(inspections) {
        let totalDefectQty = 0;

        getSortedData("Retrospective Inspection").forEach(inspection => {
            inspection.customFields.forEach(field => {
                if (field && field.FieldName === 'Defect Qty') {
                    totalDefectQty += parseInt(field.Value, 10); // Convert the value to a number and sum it
                }
            });
        });

        return totalDefectQty;
    }
    function getDefectReason(inspections) {
        const list = [];

        inspections.forEach(inspection => {
            // Safely find the defect reason and defect quantity fields
            const defectReasonField = inspection?.customFields?.find(field => field && field.FieldName === 'Defect Reason');
            const defectQtyField = inspection?.customFields?.find(field => field && field.FieldName === 'Defect Qty');

            // Safely extract the value or default to "N/A" if missing
            const reason = defectReasonField ? defectReasonField.Value : "-";
            const quantity = defectQtyField ? defectQtyField.Value : "-";

            // Only add to the list if there's valid data
            if (reason !== "-" || quantity !== "-") {
                list.push({ reason, quantity });
            }
        });

        console.log(list, "vijdnvdfjvn");
        return list;
    }


    const mergerdInspectionType = ["Process/Product Patrol Inspection", "Setup Approval Inspection", "Retrospective Inspection"]

    const getSortedData = (key, index) => {
        let data = pdfdata && pdfdata[index] && pdfdata[index][key] && pdfdata[index][key] || [];
        console.log(pdfData, data, "vbdfbdfkbj", key, index, pdfdata)
        data = data.sort((a, b) => new Date(a.DateTime).getTime() - new Date(b.DateTime).getTime());
        console.log(key, data, pdfData)
        return data
    }

    console.log(data, "vshvbhj")
    // const getRetrospecifiData = () => {
    //     const obj = { QtyChecked: 0, OK: 0, Reject: 0 }
    //     const data = getSortedData("Retrospective Inspection & Rejection Breakup");
    //     if (data.length > 0) {
    //         obj.QtyChecked = data[0].QtyToInspect
    //         obj.OK = data[0].OkParts
    //         obj.Reject = data[0].QtyToInspect - data[0].OkParts
    //     }
    //     return obj;
    // }
    const getRetrospecifiData = () => {
        const obj = { QtyChecked: 0, OK: 0, Reject: 0 }
        // const data = getSortedData("Retrospective Inspection & Rejection Breakup");
        if (data.length > 0) {
            obj.QtyChecked = data[0].QtyToInspect
            obj.OK = data[0].OkParts
            obj.Reject = 0;

            // Loop through the data array and calculate the total Reject
            data.forEach(item => {
                obj.Reject += item.QtyToInspect - item.OkParts;
            });
        }
        console.log(obj, "vfdhbdfb", data)
        return obj;
    }
    function getAllSampleRefs(inspections) {
        let allSampleRefs = [];

        inspections.forEach(inspection => {
            allSampleRefs = allSampleRefs.concat(inspection.sampleRef);
        });

        return allSampleRefs;
    }
    const demoFromHTML = async (idx) => {
        const source = customerRef.current[idx];

        if (!source) {
            console.error("Source element not found for index", idx);
            return;
        }

        // Wait for all images in the source element to load
        const loadImages = () => {
            const images = source.getElementsByTagName('img');
            const promises = Array.from(images).map((img) => {
                return new Promise((resolve) => {
                    if (img.complete) {
                        resolve();
                    } else {
                        img.onload = resolve;
                        img.onerror = resolve; // Resolve in case of error
                    }
                });
            });
            return Promise.all(promises);
        };

        // Wait for images to load
        await loadImages();

        const table = source.querySelector('table');
        const rows = Array.from(table.querySelectorAll('tr'));

        const maxRowsPerPage = 50;
        const totalRows = rows.length;
        const numPages = Math.ceil(totalRows / maxRowsPerPage);

        const pdf = new jsPDF('landscape', 'pt', 'a3',true);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();

        const margin = 20;
        const marginWidth = margin;
        const marginHeight = margin;

        const availableWidth = pdfWidth - 2 * marginWidth;
        const availableHeight = pdfHeight - 2 * marginHeight;

        for (let page = 0; page < numPages; page++) {
            const startRow = page * maxRowsPerPage;
            const endRow = Math.min((page + 1) * maxRowsPerPage, totalRows);
            const currentRows = rows.slice(startRow, endRow);

            // Temporarily hide rows not in the current page
            rows.forEach((row, index) => {
                row.style.display = (index >= startRow && index < endRow) ? '' : 'none';
            });

            // Re-render the canvas for the current page's content
            const canvasForPage = await html2canvas(source, { scale: 2 });
            const imgData = canvasForPage.toDataURL('image/jpeg', 0.7);

            const imgHeight = (canvasForPage.height * availableWidth) / canvasForPage.width;
            const position = marginHeight;

            // Add content to the PDF for the current page
            pdf.addImage(
                imgData,
                'JPEG',
                marginWidth,
                position,
                availableWidth,
                Math.min(imgHeight, availableHeight)
            );

            if (page < numPages - 1) {
                pdf.addPage();
            }
        }

        // Restore all rows after generating the PDF
        rows.forEach(row => (row.style.display = ''));

        pdf.save(`${data.InspectionType}_${new Date(data.DateTime).toLocaleString()}.pdf`);
    };

    return (
        <div>
            {pdfdata && pdfdata.map((item, idx) => <>
                <button className="btn-sm btn-primary" onClick={() => demoFromHTML(idx)}>Download PDF</button>

                <div ref={(el) => (customerRef.current[idx] = el)}>
                    <table id={''} className="table table-sm table-bordered table-hover small table-striped " style={{ padding: 0 }}>

                        <thead className='small text-center border'>
                            <tr className='text-center align-self-center '>
                                <th className='fs-2 text-start' rowSpan={1} colSpan={3}><img src={company.logo || ""} className='avatar' style={{ width: 150 }} /></th>
                                <th className='fs-6 text-start' rowSpan={1} colSpan={getSortedData("Setup Approval Inspection", idx).length + getSortedData("Process/Product Patrol Inspection", idx).length + 4}>PROCESS/ PRODUCT PATROL INSPECTION CHECK SHEET</th>

                                <th style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={getSortedData("Setup Approval Inspection", idx).length + getSortedData("Process/Product Patrol Inspection", idx).length + 2}>SHIFT NO. {extractData(data, '$..customFields[?(@.FieldName=="Shift")].Value')}</th>
                            </tr>  <tr className='text-center align-self-center '>
                                <th className='text-start' rowSpan={1} colSpan={3}>Part Name : {data.Item}</th>
                                <th className='text-start' rowSpan={1} colSpan={getSortedData("Setup Approval Inspection", idx).length + getSortedData("Process/Product Patrol Inspection", idx).length + 4}>Drg.No. / Item Code : {data.ItemNumber ? data.ItemNumber : ''}</th>
                                {/* <th className='text-start' rowSpan={1} colSpan={2}>Date : {moment(data.DateTime).format('DD-MM-YYYY')}</th> */}
                                <th style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={getSortedData("Setup Approval Inspection", idx).length + getSortedData("Process/Product Patrol Inspection", idx).length + 1}>Date : {moment(data.DateTime).format('DD-MM-YYYY')}</th>
                            </tr>  <tr className='text-center align-self-center '>
                                <th className='text-start' rowSpan={1} colSpan={3}>Operation : {data && data.Operation ? data.Operation : "-"}</th>
                                <th className='text-start' rowSpan={1} colSpan={3}>Machine No. : {extractData(data, '$..customFields[?(@.FieldName=="Machine")].Value').join(', ')}</th>
                                <th className='text-start' rowSpan={1} colSpan={getSortedData("Setup Approval Inspection", idx).length + getSortedData("Process/Product Patrol Inspection", idx).length + 1}>Batch Code :  {extractData(data, '$..customFields[?(@.FieldName=="Batch Code")].Value')}</th>

                                <th style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={getSortedData("Setup Approval Inspection", idx).length + getSortedData("Process/Product Patrol Inspection", idx).length + 1}>ROUTE CARD NO.</th>
                            </tr>
                            <tr className='text-center align-self-center '>
                                <th rowSpan={4} colSpan={1}>S.No</th>
                                <th rowSpan={4} colSpan={1}>Process / Product Characteristics</th>
                                <th rowSpan={4} colSpan={1}>Specification</th>
                                <th rowSpan={4} colSpan={1}>Type</th>
                                <th rowSpan={4} colSpan={2}>Mode of Inspection</th>
                                <th colSpan={2}>Sample</th>
                                <th colSpan={(getSortedData("Setup Approval Inspection", idx).length.length == 0 ? 1 : getSortedData("Setup Approval Inspection", idx).length) + getSortedData("Process/Product Patrol Inspection", idx).length + 1}>Observation ( All dimension are in mm unless otherwise stated ) </th>
                            </tr>
                            <tr className='text-center align-self-center '>
                                <th style={{ verticalAlign: 'middle' }} rowSpan={3}>Size</th>
                                <th style={{ verticalAlign: 'middle' }} rowSpan={3}>Freq</th>
                                <th style={{ verticalAlign: 'middle' }} colSpan={getSortedData("Setup Approval Inspection", idx).length == 0 ? 1 : getSortedData("Setup Approval Inspection", idx).length} rowSpan={2}>Setup Approval Time</th>
                                <th style={{ verticalAlign: 'middle' }} colSpan={getSortedData("Process/Product Patrol Inspection", idx).length == 0 ? 1 : getSortedData("Process/Product Patrol Inspection", idx).length}>Patrol Inspection</th>
                            </tr>
                            <tr className='text-center align-self-center '>
                                <th style={{ verticalAlign: 'middle' }} colSpan={getSortedData("Process/Product Patrol Inspection", idx).length}>Time</th>
                            </tr>
                            <tr className='text-center align-self-center '>
                                {getSortedData("Setup Approval Inspection", idx).length == 0 ?
                                    <th style={{ verticalAlign: 'middle' }} colSpan={1}>-</th> :
                                    getSortedData("Setup Approval Inspection", idx).map(x => <th style={{ verticalAlign: 'middle' }} colSpan={1}>{moment(x.DateTime).format('HH:mm a') + '/' + `${extractData(x, '$..customFields[?(@.FieldName=="LH/RH")].Value')}`}</th>)}
                                {getSortedData("Process/Product Patrol Inspection", idx).map(x => <th style={{ verticalAlign: 'middle' }} colSpan={1}>{moment(x.DateTime).format('HH:mm a') + '/' + `${extractData(x, '$..customFields[?(@.FieldName=="LH/RH")].Value')}`}</th>)}
                                {/* <th style={{ verticalAlign: 'middle' }} colSpan={1}>1</th>
                        <th style={{ verticalAlign: 'middle' }} colSpan={1}>2</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {console.log(data,"jkljhkljkkljkljlk")}
                            {data && data.Checksheet && data.Checksheet.map((one, index) => {
                                let rowSpan = 1;
                                // Calculate how many consecutive rows have the same 'Type'
                                if (index === 0 || data.Checksheet[index - 1].Type !== one.Type) {
                                    rowSpan = data.Checksheet.slice(index).filter(item => item.Type === one.Type).length;
                                }

                                console.log(rowSpan, "testing row span");

                                // Store sorted data to avoid redundant function calls
                                const setupApprovalData = getSortedData("Setup Approval Inspection", idx);
                                const processPatrolData = getSortedData("Process/Product Patrol Inspection", idx);

                                return (
                                    <tr key={index}>
                                        <th className="text-center" style={{ fontWeight: '400' }}>{one.S_No}</th>
                                        <th style={{ fontWeight: '400' }} className="text-center">{one.Process__Product_Characteristics}</th>
                                        <th style={{ fontWeight: '400' }} className="text-center">{one.Specification}</th>

                                        {/* Only display the <th> for the first occurrence of the same 'Type' */}
                                        {/* {(index === 0 || data.Checksheet[index - 1].Type !== one.Type) ? ( */}
                                        <th style={{ fontWeight: '400', verticalAlign: 'middle' }} className="text-center">
                                            {one.Type ? <img className='avatar' src={one.Type} width={25} height={25} alt="Type Avatar" /> : "NA"}
                                        </th>
                                        {/* // ) : null} */}

                                        <th className="text-center" colSpan={2} style={{ fontWeight: '400' }}>{one.Mode_Of_Inspection}</th>
                                        <th className="text-center" style={{ fontWeight: '400' }}>{one.Size}</th>
                                        <th className="text-center" style={{ fontWeight: '400' }}>{one.Freq}</th>

                                        {/* Render Setup Approval Inspection Data */}
                                        {setupApprovalData.length === 0 ? (
                                            <th className="text-center" style={{ fontWeight: '400' }}>-</th>
                                        ) : (
                                            setupApprovalData.map(check => (
                                                <th key={check.id} className="text-center" style={{ fontWeight: '400' }}>
                                                    {check.Checksheet[index] && check.Checksheet[index].StandardType === 'Dimension'
                                                        ? check.Checksheet[index]?.Data.map(x =>
                                                            x.Observed_Value + (x.Remarks ? ' - ' + x.Remarks : "")
                                                        ).join(' | ')
                                                        : check.Checksheet[index]?.Data.map(x => x.Result || "").join(' | ')}
                                                </th>

                                            ))
                                        )}

                                        {/* Render Process/Product Patrol Inspection Data */}
                                        {processPatrolData.map(check => (
                                            <th key={check.id} className="text-center" style={{ fontWeight: '400' }}>
                                                {check.Checksheet[index] && check.Checksheet[index].StandardType === 'Dimension'
                                                    ? check.Checksheet[index]?.Data.map(x =>
                                                        x.Observed_Value + (x.Remarks ? ' - ' + x.Remarks : "")
                                                    ).join(' | ')
                                                    : check.Checksheet[index]?.Data.map(x => x.Result || "").join(' | ')}
                                            </th>

                                        ))}
                                    </tr>
                                );
                            })}


                        </tbody>
                        <tfoot className='small  border'>
                            <tr className='text-center align-self-center '>
                                <td style={{ verticalAlign: 'middle' }} colSpan={7 + (getSortedData("Setup Approval Inspection", idx).length.length == 0 ? 1 : getSortedData("Setup Approval Inspection", idx).length) + getSortedData("Process/Product Patrol Inspection", idx).length}>Retrospective Inspection & Rejection Breakup</td>
                            </tr>
                            <tr className='text-center align-self-center '>
                                <td style={{ verticalAlign: 'middle' }} rowSpan={2} colSpan={1}>Quantity Checked</td>
                                <td style={{ verticalAlign: 'middle' }} rowSpan={2} colSpan={1}>{getAllSampleRefs(getSortedData("Retrospective Inspection")) && getAllSampleRefs(getSortedData("Retrospective Inspection")).length}</td>
                                <td style={{ verticalAlign: 'middle' }} rowSpan={2} colSpan={1}>Quantity OK</td>
                                <td style={{ verticalAlign: 'middle' }} rowSpan={2} colSpan={1}>{getAllSampleRefs(getSortedData("Retrospective Inspection")) && getAllSampleRefs(getSortedData("Retrospective Inspection")).filter(one => one && one.Value == 'OK').length}</td>
                                <td style={{ verticalAlign: 'middle' }} rowSpan={2} colSpan={getSortedData("Setup Approval Inspection", idx).length + getSortedData("Process/Product Patrol Inspection", idx).length - 1}>Quantity Rejected</td>
                                <td style={{ verticalAlign: 'middle' }} rowSpan={2} colSpan={1}>{getAllSampleRefs(getSortedData("Retrospective Inspection")).length - getAllSampleRefs(getSortedData("Retrospective Inspection")).filter(one => one && one.Value == 'OK').length}</td>
                                <td style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={1}>Defect 1</td>
                                <td style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={1}>Qty</td>
                                <td style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={1}>Defect 2</td>
                                <td style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={1}>Qty</td>
                            </tr>
                            <tr className='text-center align-self-center '>
                                {getSortedData("Retrospective Inspection") && getDefectReason(getSortedData("Retrospective Inspection")).length > 0 ? getDefectReason(getSortedData("Retrospective Inspection")).map(one => <><td style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={1}>{one.reason}</td>                        <td style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={1}>{one.quantity}</td> </>) : <>

                                    <td style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={1}>-</td><td style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={1}>-</td>
                                    <td style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={1}>-</td><td style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={1}>-</td>

                                </>
                                }

                                {/* <td style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={1}>{'test-vuhdfbv'}</td>
                        <td style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={1}>{12}</td>
                        <td style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={1}>{'test-vuhdfbv'}</td>
                        <td style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={1}>{12}</td> */}


                            </tr>
                            <tr>
                                <td style={{ verticalAlign: '' }} rowSpan={5} colSpan={3}>Note : <br />In case of any abnormality inform to concerned Production / QA Incharge</td>
                                <td style={{ verticalAlign: 'middle' }} rowSpan={5} colSpan={1}>Signatures</td>
                            </tr>
                            <tr className='text-center align-self-center '>
                                <td style={{ verticalAlign: 'middle' }}>Q.A</td>
                                <td colSpan={(getSortedData("Setup Approval Inspection", idx).length.length == 0 ? 1 : getSortedData("Setup Approval Inspection", idx).length) + getSortedData("Process/Product Patrol Inspection", idx).length + 3} style={{ verticalAlign: 'middle' }}>{extractData(getSortedData("Setup Approval Inspection", idx)[0], '$..customFields[?(@.FieldName=="QA Personnel")].Value')}</td>
                            </tr>
                            <tr className='text-center align-self-center '>
                                <td style={{ verticalAlign: 'middle' }} >PROD</td>
                                <td colSpan={(getSortedData("Setup Approval Inspection", idx).length.length == 0 ? 1 : getSortedData("Setup Approval Inspection", idx).length) + getSortedData("Process/Product Patrol Inspection", idx).length + 3} style={{ verticalAlign: 'middle' }}>{extractData(getSortedData("Setup Approval Inspection", idx)[0], '$..customFields[?(@.FieldName=="Production Personnel")].Value')}</td>
                            </tr>  <tr className='text-center align-self-center'>
                                <td style={{ verticalAlign: 'middle' }} >T/R</td>
                                <td colSpan={(getSortedData("Setup Approval Inspection", idx).length.length == 0 ? 1 : getSortedData("Setup Approval Inspection", idx).length) + getSortedData("Process/Product Patrol Inspection", idx).length + 3} style={{ verticalAlign: 'middle' }}>{extractData(getSortedData("Setup Approval Inspection", idx)[0], '$..customFields[?(@.FieldName=="T/R Personnel")].Value')}</td>
                            </tr>
                            <tr className='text-center align-self-center '>
                                <td style={{ verticalAlign: 'middle' }} >Maintenance</td>
                                <td colSpan={(getSortedData("Setup Approval Inspection", idx).length.length == 0 ? 1 : getSortedData("Setup Approval Inspection", idx).length) + getSortedData("Process/Product Patrol Inspection", idx).length + 3} style={{ verticalAlign: 'middle' }}>{extractData(getSortedData("Setup Approval Inspection", idx)[0], '$..customFields[?(@.FieldName=="Maintenance Personnel")].Value')}</td>
                            </tr>
                            <tr className='text-center align-self-center '>
                                <td style={{ verticalAlign: 'middle' }} colSpan={5} >General Remarks</td>
                                <td style={{ verticalAlign: 'middle' }} colSpan={(getSortedData("Setup Approval Inspection", idx).length.length == 0 ? 1 : getSortedData("Setup Approval Inspection", idx).length) + getSortedData("Process/Product Patrol Inspection", idx).length + 5} >Rejection Qty During Setting  {extractData(getSortedData("Setup Approval Inspection", idx)[0], '$..customFields[?(@.FieldName=="Rejection Qty")].Value') || '-'} </td>
                            </tr>
                            <tr className='text-center align-self-center '>
                                <td className='text-start' colSpan={(getSortedData("Setup Approval Inspection", idx).length.length == 0 ? 1 : getSortedData("Setup Approval Inspection", idx).length) + getSortedData("Process/Product Patrol Inspection", idx).length + 10} >                    FMT-QAD-07,REV. : 07 , Date : 14/02/2024
                                </td>
                            </tr>
                        </tfoot>

                    </table>  </div></>)}

        </div>
    )
}

const ProcessProductPatrolInspection = ({ company = {}, data = {}, pdfData, item = {}, test = [] }) => {
    return Object.keys(pdfData).map((key) => {
        return <ShowPdfData company={company} data={pdfData[key][data.InspectionType] && pdfData[key][data.InspectionType][0] ? pdfData[key][data.InspectionType][0] : {}} pdfData={pdfData[key]} item={item} test={test} />
    })
}

export default ProcessProductPatrolInspection